// @<COPYRIGHT>@
// ==================================================
// Copyright (c) 2026 Siemens
// Siemens Product Lifecycle Management Software Inc.
// All Rights Reserved.
// ==================================================
// @<COPYRIGHT>@

/**
 *
 * @module js/swf3dWorkspaceCallbacks
 */

/**
 * Default generate table callback
 *
 * @memberof js/swf3dWorkspaceCallbacks
 * @function _genTableCB
 * @param {object} column - table column
 * @param {object} item - table item
 * @example
 * swf3dWorkspaceCallbacks._genTableCB(column, item);
 * @returns {object} - item with Apollo's type
 */
let _genTableCB = function (column, item) {
    let colData = {
        dbValues: '',
        uiValues: '',
        type: ''
    };
    switch (column) {
        case 'object':
            colData.type = 'STRING';
            colData.dbValues = [item.urn];
            break;
        case 'name':
            colData.type = 'STRING';
            colData.dbValues = [item.name];
            colData.uiValues = [item.name];
            break;
        case 'type':
            colData.type = 'STRING';
            colData.dbValues = [item.type];
            colData.uiValues = [item.type];
            break;
        case 'date':
            colData.type = 'DATE';
            colData.dbValues = [item.lastModifiedDate];
            colData.uiValues = [item.lastModifiedDate];
            break;
        case 'createBy':
            colData.type = 'STRING';
            colData.dbValues = [item.ownerId];
            colData.uiValues = [item.ownerId];
            break;
    }
    return colData;
};

/**
 * Default checkRowDataShow
 *
 * @param {object} data - row data
 * @returns {boolean} - check if generate table row data or not.
 */
let _checkRowData = function (data) {
    return true;
};

let _selectedObjectCB = null;

/**
 * Set generate table callback
 *
 * @memberof js/swf3dWorkspaceCallbacks
 * @function setGenTableCB
 * @param {Function} fun - Generate table callback
 * @example
 * swf3dWorkspaceCallbacks.setGenTableCB(column, item);
 */
export function setGenTableCB(fun) {
    _genTableCB = fun;
}

/**
 * Get generate table callback
 *
 * @memberof js/swf3dWorkspaceCallbacks
 * @function getGenTableCB
 * @returns {Function} - Generate table callback
 */
export function getGenTableCB() {
    return _genTableCB;
}

/**
 * Set checkRowDataShow callback
 *
 * @memberof js/swf3dWorkspaceCallbacks
 * @function setCheckRowDataShowCB
 * @param {Function} fun - callback
 * @example
 * swf3dWorkspaceCallbacks.setCheckRowDataShowCB(()=>{});
 */
export function setCheckRowDataShowCB(fun) {
    _checkRowData = fun;
}

/**
 * Get checkRowDataShow callback
 *
 * @memberof js/swf3dWorkspaceCallbacks
 * @function getCheckRowDataShowCB
 * @returns {Function} - Check row data show callback
 */
export function getCheckRowDataShowCB() {
    return _checkRowData;
}

/**
 * Set selectionChangedAction callback
 *
 * @param {Function} fun - selectedObject callback
 */
export function setSelectedObjectCB(fun) {
    _selectedObjectCB = fun;
}

/**
 * Get selectionChangedAction callback
 *
 * @returns {Function} - selectedObject callback
 */
export function getSelectedObjectCB() {
    return _selectedObjectCB;
}

export default {
    setGenTableCB,
    getGenTableCB,
    setCheckRowDataShowCB,
    getCheckRowDataShowCB,
    setSelectedObjectCB,
    getSelectedObjectCB
};
